import { useEffect } from "react";
import { hydrate } from "preact-iso";
import { GlobalStateProvider, useGlobalState } from "./contexts/globalContext";
import Widget from "./components/Widget/Widget";
import "./base.scss";

const widgetName = import.meta.env.VITE_WIDGET_NAME;

export function App() {
  const { isDarkMode } = useGlobalState();

  useEffect(() => {
    const body = document.documentElement;

    if (isDarkMode) {
      body.classList.add("ds-dark");
    } else {
      body.classList.remove("ds-dark");
    }

    return () => {
      body.classList.remove("ds-dark");
    };
  }, [isDarkMode]);

  return (
    <main>
      <Widget widgetName={widgetName} />
    </main>
  );
}

if (typeof window !== "undefined") {
  const rootElement = document.getElementById("app");
  if (rootElement) {
    hydrate(
      <GlobalStateProvider>
        <App />
      </GlobalStateProvider>,
      rootElement
    );
  } else {
    console.error("Root element not found");
  }
}
